import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'

const title = '岗位助手'

// 去掉右上角loading圈
NProgress.configure({
  showSpinner: false
})

function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  // 设置页面标题
  document.title = getPageTitle(to.meta.title)

  const TOKEN = sessionStorage.getItem('token')
  const menuList = store.state.user.menuList

  // 存在token
  if (TOKEN) {
    // 存在token 再通过url去到login页面会进行拦截 回到首页
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done()
    } else {
      // 用户信息是否存在
      let userInfo = store.state.user.userInfo
      if (!userInfo) userInfo = await store.dispatch('user/getInfo')
      // 需要修改初始密码后才能使用
      if (userInfo.isChangePassword === '0' && to.path !== '/account') {
        Message({
          type: 'warning',
          message: '为了保护您的账号安全，请修改初始密码后再使用'
        })
        next({
          path: '/account'
        })
        NProgress.done()
      }
      // 在判断菜单信息是否存在
      if (menuList && menuList.length > 0) {
        next()
      } else {
        // 不存在重新获取
        try {
          await store.dispatch('user/getMenu')
          next({
            ...to,
            replace: true
          })
        } catch (err) {
          // 获取失败 重置token并返回登录页
          await store.dispatch('user/resetAuth')
          next({
            path: '/login'
          })
          NProgress.done()
        }
      }
    }
  } else {
    // 获取登录code
    const url = location.href
    const businessCode = process.env.NODE_ENV === 'production' ? url.split('?').pop() : 'b0WTvkTsVf0%3D'
    store.commit('user/setBusinessCode', businessCode)
    // 不存在token 判断path是否为login
    if (to.path === '/login') {
      // 是则next
      next()
    } else {
      // 反之重定向到登录页
      next({
        path: `/login?${businessCode}`
      })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
